(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/bubble-usp.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/bubble-usp.js');
"use strict";

const {
  useRef,
  useEffect,
  useState,
  useCallback,
  memo
} = React;
const {
  ANIMATIONS: {
    USP,
    USP_BACKGROUND
  }
} = svs.tickets.play.utils.constants;
const {
  Image
} = svs.content.image_v2;
const ImageMemo = memo(_ref => {
  let {
    image
  } = _ref;
  return React.createElement(Image, {
    image: image
  });
});
setGlobal('svs.tickets.play.components.BubbleUsp', _ref2 => {
  let {
    appTimeline,
    ticketPitchImage,
    shouldPlayAnimation,
    onAnimationEnd,
    isFirstTime
  } = _ref2;
  const bubbleRef = useRef(null);
  const imgRef = useRef(null);
  const [hasShownInitialUsp, setHasShownInitialPromo] = useState(false);
  const showUsp = useCallback(() => {
    const showTimeline = gsap.timeline();
    showTimeline.to(imgRef.current, USP.duration, {
      y: '-30%',
      ease: 'elastic.out(1, 0.4)'
    }, "showUsp+=".concat(USP.duration - USP_BACKGROUND.duration));
    showTimeline.to(bubbleRef.current, USP_BACKGROUND.duration, {
      background: 'rgba(0,0,0,0.5)',
      backdropFilter: 'blur(6px)',
      ease: 'linear',
      onStart: () => {
        bubbleRef.current && (bubbleRef.current.style.display = 'flex');
      }
    }, 'showUsp');
    return showTimeline;
  }, []);
  const hideUsp = useCallback(() => {
    const hideTimeline = new gsap.timeline();
    hideTimeline.to(imgRef.current, 1, {
      y: '-150%',
      ease: 'elastic.in(1.2, 0.75)'
    }, 'hideUsp');
    hideTimeline.to(bubbleRef.current, 0.6, {
      background: 'rgba(0,0,0,0)',
      backdropFilter: 'blur(0px)',
      ease: 'linear',
      onComplete: () => {
        bubbleRef.current && (bubbleRef.current.style.display = 'none');
        onAnimationEnd();
        setHasShownInitialPromo(true);
      }
    }, "hideUsp+=".concat(USP.duration - USP_BACKGROUND.duration));
    return hideTimeline;
  }, [onAnimationEnd]);
  useEffect(() => {
    if (isFirstTime) {
      var _imgRef$current;
      let unmounted = false;
      appTimeline.pause();
      const showTimeline = showUsp();
      const hideTimeline = hideUsp();
      appTimeline.add(showTimeline, 'showUsp');
      appTimeline.add(hideTimeline, 'hideUsp');
      appTimeline.pause();
      const resumeUsp = () => {
        if (unmounted) {
          return;
        }
        unmounted = true;
        setTimeout(() => {
          appTimeline.seek('showUsp');
          appTimeline.resume();
        }, 0);
      };
      const img = (_imgRef$current = imgRef.current) === null || _imgRef$current === void 0 ? void 0 : _imgRef$current.querySelector('img');
      if (img !== null && img !== void 0 && img.complete) {
        resumeUsp();
      } else if (img) {
        img.onload = resumeUsp;
        img.onerror = resumeUsp;
      }
      return () => {
        unmounted = true;
        showTimeline.kill();
        hideTimeline.kill();
      };
    }
    setHasShownInitialPromo(true);
  }, []);
  useEffect(() => {
    if (shouldPlayAnimation) {
      showUsp(0.4, true);
    }
  }, [shouldPlayAnimation, hasShownInitialUsp, showUsp]);
  return React.createElement("div", {
    className: "bubble-usp-overlay",
    onClick: () => {
      if (hasShownInitialUsp) {
        hideUsp();
      } else {
        appTimeline.seek('hideUsp');
      }
    },
    ref: bubbleRef
  }, React.createElement("div", {
    className: "bubble-usp-image",
    ref: imgRef
  }, React.createElement(ImageMemo, {
    image: ticketPitchImage
  })));
});

 })(window);